// LocalStorage manager for "Recently Viewed" refurbished devices.
// Stores up to MAX entries: [{ id, viewed_at }] keyed by listing id, most-recent first.
const KEY = 'refurb_recently_viewed_v1';
const MAX = 12;

export function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(x => x && x.id) : [];
  } catch {
    return [];
  }
}

export function recordView(id) {
  if (!id) return;
  try {
    const list = getRecentlyViewed().filter(x => x.id !== id);
    list.unshift({ id, viewed_at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {/* ignore quota errors */}
}

export function clearRecentlyViewed() {
  try { localStorage.removeItem(KEY); } catch {/* ignore */}
}

export function getRecentlyViewedIds() {
  return getRecentlyViewed().map(x => x.id);
}
